import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { ReservationDetailPage } from '../../components/ReservationDetailPage';
import { TRANSFER_CAPS } from '../../components/reservation/capabilities';
import TransferFlowPage from './pages/TransferFlowPage';
import TransferReservationsPage from './pages/TransferReservationsPage';

/** Clicking a PNR/ticket number in "Rezervasyon Listesi" navigates to
 *  `transfer/reservations/:identifier` — the shared `ReservationDetailPage` (see
 *  ../../components/ReservationDetailPage.tsx), re-fetched fresh via `Entry/Find`. No
 *  İptal Et — the transfer provider offers no post-sale cancellation (legacy had none
 *  either; see docs/backend-requirements.md GEREK YOK). Info + documents only. */
export const transferModule: ModuleDefinition = {
  routes: [
    { path: 'transfer', element: <TransferFlowPage /> },
    { path: 'transfer/reservations', element: <TransferReservationsPage /> },
    {
      path: 'transfer/reservations/:identifier',
      element: <ReservationDetailPage capabilities={TRANSFER_CAPS} />,
    },
  ],
  menuItems: [
    {
      label: 'Arama',
      path: 'transfer',
      icon: <DirectionsCarFilledOutlinedIcon />,
      group: 'Transfer',
      groupIcon: <DirectionsCarFilledOutlinedIcon />,
    },
    {
      label: 'Rezervasyon Listesi',
      path: 'transfer/reservations',
      icon: <ListAltOutlinedIcon />,
      group: 'Transfer',
    },
  ],
};
